// extracted by mini-css-extract-plugin
module.exports = {"partnerLogo":"icons_partnerLogo__gsigq","forbesLogo":"icons_forbesLogo__4_rww"};